import { useSelector } from "../../hooks";
import { QuizRoutes } from "./QuizRoutes";
import { Loader } from "../../components/Loader/Loader";
import { ErrorSnackbar } from "../../components/ErrorSnackbar/ErrorSnackbar";

export const QuizPage = () => {
    const { error, loading } = useSelector(store => store.quiz);

    return (
        <>
            <QuizRoutes />
                        
            { loading && <Loader /> }
            { error.length > 0 && <ErrorSnackbar errorMessage={ error } /> }
        </>
    );
}